export var createWebhooksApi = function (baseUrl, http) {
    return {
        getWebhooks: function () { return http.get(baseUrl + "/webhooks"); },
        addWebhook: function (dto) { return http.post(baseUrl + "/webhooks", dto); },
        updateWebhook: function (dto) { return http.put(baseUrl + "/webhooks/" + dto.id, dto.data); },
        deleteWebhook: function (id) { return http.delete(baseUrl + "/webhooks/" + id); }
    };
};
//# sourceMappingURL=index.js.map